/**
 * Catálogo de asignación (Nueva Tarea, reasignación).
 * Orden del organigrama: ciudad → área → persona.
 * La torre/subárea ya no es un paso del formulario; se refleja en la etiqueta del usuario.
 */

function escapeHtmlLite(text) {
  return String(text ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/** @deprecated Mantenido por compatibilidad; la asignación ya no usa paso de torre. */
export const AREA_IDS_WITHOUT_SUB_AREA_STEP = new Set([1]);

const localeEsCompare = { sensitivity: 'base' };

const compareSubAreaByName = (a, b) =>
  String(a.name || '').localeCompare(String(b.name || ''), 'es', localeEsCompare);

export const SUB_AREA_OTHERS_GROUP_LABEL = 'Otros roles y torres';

/**
 * Asignación / reasignación: siempre ciudad → área → usuario (sin paso Torre).
 * @param {number|string|null} areaId
 * @param {Array<{id:number|string,name?:string}>} areasList
 */
export function areaRequiresSubAreaStep(areaId, areasList = []) {
  void areaId;
  void areasList;
  return false;
}

/** Etiqueta en select de usuario: nombre + cargo + torre/subárea. */
export function formatAssigneeOptionLabel(user) {
  const name = [user?.first_name, user?.last_name].filter(Boolean).join(' ').trim()
    || user?.username
    || user?.email
    || '—';
  const position = user?.position_name || user?.position?.name || '';
  const subArea = user?.sub_area_name || user?.sub_area?.name || '';
  const meta = [position, subArea].filter(Boolean).join(' · ');
  return meta ? `${name} — ${meta}` : name;
}

export function mapUsersToChoiceOptions(users) {
  return (users || []).map((user) => ({
    value: user.id,
    label: formatAssigneeOptionLabel(user),
  }));
}

/** Grupos Choices.js para torres/subáreas (misma lógica que Nueva Tarea). */
export function buildSubAreaGroupedChoicesForSelect(subAreas) {
  const rows = (subAreas || [])
    .map((s) => ({
      id: s.id,
      name: String(s.name ?? '').trim(),
      description: String(s.description ?? '').trim(),
    }))
    .filter((r) => r.name);

  if (rows.length === 0) return [];

  const buckets = new Map();
  const withoutDescription = [];

  for (const row of rows) {
    if (row.description) {
      if (!buckets.has(row.description)) buckets.set(row.description, []);
      buckets.get(row.description).push(row);
    } else {
      withoutDescription.push(row);
    }
  }

  const groups = [];
  const singles = [...withoutDescription];

  const descKeys = [...buckets.keys()].sort((a, b) => a.localeCompare(b, 'es', localeEsCompare));
  for (const key of descKeys) {
    const items = [...buckets.get(key)].sort(compareSubAreaByName);
    if (items.length >= 2) {
      groups.push({
        label: escapeHtmlLite(key),
        disabled: false,
        choices: items.map((it) => ({
          value: String(it.id),
          label: escapeHtmlLite(it.name),
        })),
      });
    } else {
      singles.push(...items);
    }
  }

  singles.sort(compareSubAreaByName);
  if (singles.length > 0) {
    groups.push({
      label: SUB_AREA_OTHERS_GROUP_LABEL,
      disabled: false,
      choices: singles.map((it) => ({
        value: String(it.id),
        label: escapeHtmlLite(it.name),
      })),
    });
  }

  groups.sort((a, b) => {
    const aOt = a.label === SUB_AREA_OTHERS_GROUP_LABEL;
    const bOt = b.label === SUB_AREA_OTHERS_GROUP_LABEL;
    if (aOt !== bOt) return aOt ? 1 : -1;
    return a.label.localeCompare(b.label, 'es', localeEsCompare);
  });

  return groups;
}
